import React, { useCallback, useEffect, useState } from 'react';
import { AiFloatButton, ChatDrawer } from '@/components';
import { usePostMessage } from '@/hooks';
import type { InboundInit } from '@/types/bridge';
import { useChatStore } from '@/store';
import { applyInitPayload } from '@/utils/applyInitPayload';
import { ESolutionCode } from '@/types';
import { setCommon, setUserInfo } from '@/common';
import { setLanguage } from '@/i18n';
import { initGoogleAnalytics } from '@/utils/ga';

const WidgetApp: React.FC = () => {
  const [options, setOptions] = useState<InboundInit['payload']>({
    config: { close: true, fullScreen: false },
  });
  const [isReady, setIsReady] = useState(false);
  const initRoles = useChatStore((s) => s.initRoles);
  const isOpen = useChatStore((s) => s.isOpen);

  const handleInit = useCallback(
    (payload: InboundInit['payload']) => {
      setOptions({
        ...payload,
        config: {
          close: true,
          fullScreen: false,
          ...payload.config,
        },
      });
      applyInitPayload(payload);
      const solutionCode = payload?.solution_code as string;
      void initRoles(solutionCode)
        .catch((err) => {
          console.error('[initRoles] failed:', err);
        })
        .finally(() => {
          setIsReady(true);
        });
    },
    [initRoles],
  );

  const { send } = usePostMessage({ onInit: handleInit });

  useEffect(() => {
    send({ type: isOpen ? 'widget-open' : 'widget-close' });
  }, [isOpen, send]);

  // 本地 dev：无 embed loader 时自动注入 mock（?mode=widget）
  useEffect(() => {
    if (window.parent !== window) return;

    let cancelled = false;
    const solutionCode = ESolutionCode.BOSS_REPORT;
    setCommon(
      'token',
      'eyJ6aXAiOiJERUYiLCJhbGciOiJFUzI1NiJ9.eJwdjEEOgjAQRe8yaxbttNNOOYQrLlBbaiCgWJCYGO_ihlt4He5hZfXzX17eC_qlgxrQeR-DYRWc0Ciss5Ysy4iaiBQnqKB9TlBLy0zMRukKOr8cgJwzB_BTMSD4qKLSUvmQNJN0OnE4R2ox2tB6WVKPORfRoCGN5c7LBWpRwS2XhebUIEqh5DpMYz-4YNexFz7dBxVN7kxy_0K-FnX_fvZtg_cPJlc4Wg.8Wa3Rgmg90uJoPGhNXdvo6vlZWWaF251282f_CNHPWL33nkhzMWkY81oQkWPeYUweoINKcnOFxO083nfjUgfwg',
    );
    setCommon('storeId', 'S002605082410036635');
    setCommon('tenantCode', 'TNT221031vlpmjl9c7vmj0afql3d6ri6f9');
    const mockLang = 'zh-CN';
    setCommon('language', mockLang);
    setLanguage(mockLang);
    setCommon('bizType', 'restaurant');
    setCommon('solution_code', solutionCode);
    setCommon('source', 'GPOS_WEB');
    setUserInfo('ye.tao@sunmi.com', '373275', '18937107705');
    useChatStore.getState().syncHistoryScope();
    useChatStore.getState().setHostInitialized(true);
    initGoogleAnalytics();
    void initRoles(solutionCode)
      .catch((err) => {
        console.error('[initRoles] failed:', err);
      })
      .finally(() => {
        if (!cancelled) {
          setIsReady(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [initRoles]);

  return (
    <>
      <AiFloatButton />
      <ChatDrawer options={options} isReady={isReady} />
    </>
  );
};

export default WidgetApp;
